import { getImageUrl } from '@app/utils/getImageUrl';
import { Stack, Text } from '@redbubble/design-system';
import { FormattedMessage, useIntl } from '@redbubble/next/intl';
import Image from 'next/legacy/image';
import { ReactNode } from 'react';

export const EmptyCartGraphic = ({ message }: { message?: ReactNode }) => {
  const intl = useIntl();

  const emptyCartAlt = intl.formatMessage({ defaultMessage: 'Empty Cart' });

  return (
    <Stack alignItems="center">
      <Image
        alt={emptyCartAlt}
        layout="fixed"
        src={getImageUrl('/icons/empty-cart.svg')}
        width={140}
        height={177}
      />
      <Text marginTop="m">
        {message ?? (
          <FormattedMessage defaultMessage="You don’t have any items in your cart." />
        )}
      </Text>
    </Stack>
  );
};
